import { ProductVariationBase } from 'models/productsReferential';
import { createSelector } from 'reselect';
import { AppState } from 'state/state.model';

import type { ProductDescriptionState } from './model';
import type { StaticProductView } from './types';

export function getAllExistingProducts(state: ProductDescriptionState, view: StaticProductView) {
  if (state.products && state.products[view]) {
    return Object.keys(state.products[view]);
  }
}

export function selectProductDescription(
  state: ProductDescriptionState,
  view: StaticProductView,
  productSubType: string,
  productType: string,
) {
  if (state.products && state.products[view] && productType && productSubType) {
    return state.products[view][productType]?.[productSubType];
  }
}

export function getAddonDescriptions(state: AppState) {
  return state.productDescription.addonDescriptions;
}

export function getAllGimmicksDescription(state: ProductDescriptionState) {
  return state.gimmicks;
}

export function hasProductDescriptionFailure(state: AppState): boolean {
  return state.productDescription.status === 'error' || state.productDescription.status === 'timeout';
}
export function isProductDescriptionLoading(state: AppState): boolean {
  return state.productDescription.status === 'loading';
}

export function getAllProductSubTypes(state: ProductDescriptionState, view: StaticProductView): string[] {
  const subTypes: string[] = [];
  if (state.products && state.products[view]) {
    Object.keys(state.products[view]).forEach(productType => {
      subTypes.push(...Object.keys(state.products[view][productType] || {}));
    });
  }
  return subTypes;
}

export function getProductVariations(state: ProductDescriptionState, view: StaticProductView): ProductVariationBase[] {
  const variations: ProductVariationBase[] = [];
  if (state.products && state.products[view]) {
    Object.keys(state.products[view]).forEach(productType => {
      Object.keys(state.products[view][productType] || {}).forEach(productSubType => {
        variations.push({ productType, productSubType });
      });
    });
  }
  return variations;
}
export const selectProductDescriptionStatus = createSelector(
  [(state: AppState) => state.productDescription.status],
  status => {
    const isLoading = !status || status === 'loading';
    const isTimeout = status === 'timeout';
    const isError = status === 'error';
    const isSuccess = status === 'success';

    return { isError, isTimeout, isLoading, isSuccess, status };
  },
);
